<div class="px-3">
    <div class="rem-text-default mb-6">
        <div class="flex align-items-end">
            <div class="rem-bg-light px-3 py-3 mr-2">
                <i class="pi pi-fast-forward font-medium text-xl"></i>
            </div>
            <div>
                <div class="text-2xl font-medium">Payment Plan Forecast</div>
                <div class="text-right mt-2">View total commited payment plan forecast of creditors</div>
            </div>
        </div>
    </div>
    <div class="flex justify-content-between align-items-center mt-4 pr-4">
        <div class="flex align-items-center gap-2">
            <p-floatLabel>
              <p-multiSelect
                [style]="{width: '200px'}"
                id="creditors"
                [options]="clients"
                [(ngModel)]="selectedClients"                
                optionLabel="CompanyName"          
                filterBy="CreditorId,CompanyName">
                <ng-template let-creditor pTemplate="item">
                  <div class="flex align-items-center justify-content-between flex-1">
                    <div>{{ creditor.CompanyName }}</div>
                    <div class="ml-2">{{ creditor.CreditorId }}</div>
                  </div>
                </ng-template>
              </p-multiSelect>
            <label for="creditors">Select Clients</label>
            </p-floatLabel>
            
            <p-floatLabel>
              <p-calendar 
                    id="startDate"
                    [(ngModel)]="startDate"
                    [readonlyInput]="true"                          
              />
              <label for="startDate">From Date</label>
            </p-floatLabel>

            <remitter-button                
                (click)="getData()" 
                label="Search" 
                icon="search" 
                severity="secondary">
            </remitter-button>
        </div>
       
    </div>
    <br />
    <div *ngIf="tableData.length" class="mt-4 pt-2 px-3">
        <p-table *ngIf="tableData.length > 0" [value]="tableData" [paginator]="true" [rows]="20" [tableStyle]="{ 'min-width': '50rem' }" [rowsPerPageOptions]="[20, 50, 100]">
            <ng-template pTemplate="header">
                <tr>
                    <th></th>
                    <th>Creditor Id</th>
                    <th>Creditor Name</th>
                    <th>Total Committed (Total Count) </th>                    
                    <th *ngFor="let index of monthIndexes">
                        {{ monthFromStartDate(index) }}
                    </th>

                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>
                        <div class="flex" pTooltip="Open Details" (click)="openDetails(item.creditorId)">
                            <icon-button icon="folder-open" />
                        </div>
                    </td>
                    <td>{{ item.creditorId }}</td>
                    <td>{{ item.creditorName }}</td>
                    <td>
                        <span class="font-bold">{{ item.totalPerCreditor }}</span><span> ({{ item.totalCountPerCreditor }})</span>
                    </td>                    
                    <td>
                        <span [pTooltip]="'Committed on '+monthFromStartDate(0)" class="font-bold">{{ item.month1 }}</span>
                        <span [pTooltip]="'Count on '+monthFromStartDate(0)"> ({{ item.count1 }})</span> </td>
                    <td>
                        <span [pTooltip]="'Committed on '+monthFromStartDate(1)" class="font-bold">{{ item.month2 }}</span>
                        <span [pTooltip]="'Count on '+monthFromStartDate(1)"> ({{ item.count2 }})</span> </td>
                    <td>
                        <span [pTooltip]="'Committed on '+monthFromStartDate(2)" class="font-bold">{{ item.month3 }}</span>
                        <span [pTooltip]="'Count on '+monthFromStartDate(2)"> ({{ item.count3 }})</span> </td>
                    <td>
                        <span [pTooltip]="'Committed on '+monthFromStartDate(3)" class="font-bold">{{ item.month4 }}</span>
                        <span [pTooltip]="'Count on '+monthFromStartDate(3)"> ({{ item.count4 }})</span> </td>
                    <td>
                        <span [pTooltip]="'Committed on '+monthFromStartDate(4)" class="font-bold">{{ item.month5 }}</span>
                        <span [pTooltip]="'Count on '+monthFromStartDate(4)"> ({{ item.count5 }})</span> </td>
                    <td>
                        <span [pTooltip]="'Committed on '+monthFromStartDate(5)" class="font-bold">{{ item.month6 }}</span>
                        <span [pTooltip]="'Count on '+monthFromStartDate(5)"> ({{ item.count6 }})</span> </td>
                    <td>
                        <span [pTooltip]="'Committed on '+monthFromStartDate(6)" class="font-bold">{{ item.month7 }}</span>
                        <span [pTooltip]="'Count on '+monthFromStartDate(6)"> ({{ item.count7 }})</span> </td>
                    <td>
                        <span [pTooltip]="'Committed on '+monthFromStartDate(7)" class="font-bold">{{ item.month8 }}</span>
                        <span [pTooltip]="'Count on '+monthFromStartDate(7)"> ({{ item.count8 }})</span> </td>
                    <td>
                        <span [pTooltip]="'Committed on '+monthFromStartDate(8)" class="font-bold">{{ item.month9 }}</span>
                        <span [pTooltip]="'Count on '+monthFromStartDate(8)"> ({{ item.count9 }})</span> </td>
                    <td>
                        <span [pTooltip]="'Committed on '+monthFromStartDate(9)" class="font-bold">{{ item.month10 }}</span>
                        <span [pTooltip]="'Count on '+monthFromStartDate(9)"> ({{ item.count10 }})</span> </td>
                    <td>
                        <span [pTooltip]="'Committed on '+monthFromStartDate(10)" class="font-bold">{{ item.month11 }}</span>
                        <span [pTooltip]="'Count on '+monthFromStartDate(10)"> ({{ item.count11 }})</span> </td>
                    <td>
                        <span [pTooltip]="'Committed on '+monthFromStartDate(11)" class="font-bold">{{ item.month12 }}</span>
                        <span [pTooltip]="'Count on '+monthFromStartDate(11)"> ({{ item.count12 }})</span> </td>

                </tr>
            </ng-template>
        </p-table>
    </div>

    <br/>
        <div class="chart-div pt-5">
            <div class="font-bold text-700 text-lg">Total Committed by Creditor</div>
            <div *ngIf="isArrayWithData(chartOptions)">
              <div
                  *ngFor="let chart of chartOptions; let i = index"
                  echarts
                  [options]="chart"
                  class="echart"
                  [ngStyle]="{ minHeight: chart['dataLength'] === 10? 'auto' : getGraphHeight(chart['dataLength']) }"
              ></div>
            </div>
             <div *ngIf="!isArrayWithData(chartOptions)" class="flex align-items-center justify-content-center h-20rem">
               <div class="font-bold text-red-700">There is no data to display. Please adjust your filter.</div>
             </div>
        </div>


    <p-sidebar [(visible)]="isOpenDetails" styleClass="w-8" position="right">
        <ng-template pTemplate="header"> 
            <h3 class="font-bold text-xl">Details</h3>
        </ng-template>

        <p-table 
             *ngIf="tableDetails.length > 0"
             [value]="tableDetails" 
             [paginator]="true" 
             [rows]="20" 
             [tableStyle]="{ 'min-width': '50rem' }" 
             [rowsPerPageOptions]="[20, 50, 100]">
            <ng-template pTemplate="header">
                <tr>
                    <th>AccountInvoiceId</th>
                    <th>IntegrationLinkId</th>
                    <th>Frequency</th>
                    <th>Recurring Amount</th>
                    <th>Due Date</th>
                    <th>Payment Type</th>
                    <th>Payment Status</th>
                    <th>Reference</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>{{ item.accountInvoiceId }}</td>
                    <td>{{ item.integrationLinkId }}</td>
                    <td>{{ item.paymentFrequency }}</td>
                    <td>{{ item.recurringAmount }}</td>
                    <td>{{ item.dueDate }}</td>
                    <td>{{ item.paymentType }}</td>
                    <td>{{ item.paymentStatus }}</td>
                    <td>{{ item.transactionId }}</td>
                </tr>
            </ng-template>
        </p-table>
    </p-sidebar>

